// Todo: Reliably track when remote user mutes their video (already done in p2p)
// Todo: Switching comm mode creates new stats collector
export default class LiveSwitchConnectionStats{
    constructor(options){
        this.audioOnlyBandwidth = 40;
        this.videoMutedBandwidth = 100;
        this.maxVideoBitrate = (options.maxVideoBitrate && options.maxVideoBitrate > 0) ? options.maxVideoBitrate : 0;  // Server limit

        this.currentMaxBitrate = this.maxVideoBitrate;

        this.connection = options.connection;
        this.userId = options.userId;

        this.collectionInterval = (options.hasOwnProperty('interval')) ? options.interval : 1000;

        this.webRTCHandler = options.webRTCHandler;

        this.collector = null;
        this.connectionInfo = null;
        this.previousStats = null;

        this.lastUpdateTime = 0;

        this.calculateRates = function(previousStats, currentStats){
            if(!currentStats){
                return;
            }

            let timeDifferenceSeconds = null;
            if(previousStats && previousStats.timestamp){
                const timeDifferenceTicks = (currentStats.timestamp.getTicks() - previousStats.timestamp.getTicks());
                timeDifferenceSeconds = timeDifferenceTicks / 10000000;
            }

            for (let prop in currentStats) {
                if(prop !== 'timestamp'){
                    const currentRate = (timeDifferenceSeconds) ? (Math.ceil((currentStats[prop] - previousStats[prop]) / timeDifferenceSeconds)) : 0;
                    currentStats[prop + 'Rate'] = currentRate
                }
            }
        };

        this.getStreamStats = function(stream, type){
            const previousStreamStats = this.previousStats[type];

            const transport = stream.getTransport();

            const transportStats =  {
                bytesReceived: transport.getBytesReceived(),
                bytesSent: transport.getBytesSent(),
                timestamp: transport.getTimestamp()
            }

            this.calculateRates(previousStreamStats.transport, transportStats);

            const activeCandidatePair = transport.getActiveCandidatePair();

            let activeCandidatePairStats = null;
            if(activeCandidatePair){
                activeCandidatePairStats = {
                    bytesReceived: activeCandidatePair.getBytesReceived(),
                    bytesSent: activeCandidatePair.getBytesSent(),
                    timestamp: activeCandidatePair.getTimestamp()
                }

                this.calculateRates(previousStreamStats.activeCandidatePair, activeCandidatePairStats);
            }

            const sender = stream.getSender();
            let senderStats = null;
            let senderTrackStats = null;
            if(sender){
                senderStats =  {
                    bytesSent: sender.getBytesSent(),
                    packetsSent: sender.getPacketsSent(),
                    nackCount: sender.getNackCount(),
                    timestamp: sender.getTimestamp()
                }

                this.calculateRates(previousStreamStats.sender, senderStats)

                const senderTrack = sender.getTrack();
                if(type === 'video' && senderTrack){
                    senderTrackStats = {
                        framesSent: senderTrack.getFramesSent(),
                        timestamp: senderTrack.getTimestamp()
                    }

                    this.calculateRates(previousStreamStats.senderTrack, senderTrackStats);

                    senderTrackStats.frameWidth = senderTrack.getFrameWidth();
                    senderTrackStats.frameHeight = senderTrack.getFrameHeight();
                    senderTrackStats.frameRate = senderTrack.getFrameRate();
                }
            }

            const receiver = stream.getReceiver();
            let receiverStats = null;
            let receiverTrackStats = null;
            if(receiver){
                receiverStats =  {
                    bytesReceived: receiver.getBytesReceived(),
                    packetsReceived: receiver.getPacketsReceived(),
                    packetsLost: receiver.getPacketsLost(),
                    nackCount: receiver.getNackCount(),
                    timestamp: receiver.getTimestamp()
                }

                this.calculateRates(previousStreamStats.receiver, receiverStats);

                const receiverTrack = receiver.getTrack();
                if(type === 'video' && receiverTrack){
                    receiverTrackStats = {
                        framesReceived: receiverTrack.getFramesReceived(),
                        timestamp: receiverTrack.getTimestamp()
                    }

                    this.calculateRates(previousStreamStats.receiverTrack, receiverTrackStats);

                    receiverTrackStats.frameWidth = receiverTrack.getFrameWidth();
                    receiverTrackStats.frameHeight = receiverTrack.getFrameHeight();
                    receiverTrackStats.frameRate = receiverTrack.getFrameRate();
                }
            }

            const streamStats = {
                transport: transportStats,
                activeCandidatePair: activeCandidatePairStats,
                sender: senderStats,
                receiver: receiverStats

            }

            if(type === 'video'){
                streamStats.senderTrack = senderTrackStats;
                streamStats.receiverTrack = receiverTrackStats;
            }

            this.previousStats[type] = streamStats;

            return streamStats;
        };

        this.getConnectionStats = function(){
        	const _this = this;

            return this.connection.getStats()
            .then(function(connectionStats){
                const stats = {
                    audio: null,
                    video: null,
                    transport: {bytesReceivedRate: 0, bytesSentRate: 0}
                }

                if(connectionStats.getAudioStream()){
                    const streamStats = _this.getStreamStats(connectionStats.getAudioStream(), 'audio');

                    stats.audio = streamStats;

                    //stats.transport = streamStats.transport;
                    stats.transport = (streamStats.activeCandidatePair) ? streamStats.activeCandidatePair : streamStats.transport;
                }
                if(connectionStats.getVideoStream()){
                    const streamStats = _this.getStreamStats(connectionStats.getVideoStream(), 'video');

                    stats.video = streamStats;

                    // If no audio stream, take transport stats from video stream (e.g. screenshare)
                    if(!connectionStats.getAudioStream()){
                        //stats.transport = streamStats.transport;
                        stats.transport = (streamStats.activeCandidatePair) ? streamStats.activeCandidatePair : streamStats.transport;
                    }
                }

                const userStats = {
                    userId: _this.userId,
                    stats: stats
                }

                // Reduced stats for Jitsi compatibility
                /////////////////////////////////////////
                let connectionQualityFromPacketLoss = false;
                let packetsLost = 0;
                let frameRate = {download: null, upload: null};
                let resolution = {download: null, upload: null};

                if(stats.video){
                    if(stats.video.receiver){
                        //connectionQualityFromPacketLoss = true;
                        packetsLost += stats.video.receiver.packetsLostRate;
                    }

                    if(stats.video.senderTrack){
                        frameRate.upload = stats.video.senderTrack.framesSentRate;
                        resolution.upload = stats.video.senderTrack.frameWidth + 'x' + stats.video.senderTrack.frameHeight;
                    }
                    if(stats.video.receiverTrack){
                        frameRate.download = stats.video.receiverTrack.framesReceivedRate;
                        resolution.download = stats.video.receiverTrack.frameWidth + 'x' + stats.video.receiverTrack.frameHeight;
                    }
                }

                if(stats.audio && stats.audio.receiver){
                    //connectionQualityFromPacketLoss = true;
                    packetsLost += stats.audio.receiver.packetsLostRate;
                }

                const kilobitReceivedRate = (stats.transport.bytesReceivedRate * 8) / 1024;
                const kilobitSentRate = (stats.transport.bytesSentRate * 8) / 1024;

                let connectionQuality = 0;
                if(connectionQualityFromPacketLoss){
                    if (packetsLost <= 2) {
                        connectionQuality = 100; // Full 5 bars.
                    } else if (packetsLost <= 4) {
                        connectionQuality = 70; // 4 bars
                    } else if (packetsLost <= 6) {
                        connectionQuality = 50; // 3 bars
                    } else if (packetsLost <= 8) {
                        connectionQuality = 30; // 2 bars
                    } else if (packetsLost <= 12) {
                        connectionQuality = 10; // 1 bars
                    } else {
                        connectionQuality = 0; // Still 1 bar, but slower climb-up.
                    }
                }
                else{
                    const milliSecSinceStart = window.performance.now() - _this.timeConnected;
                    if (milliSecSinceStart < 5000){
                        connectionQuality = 100;
                    }
                    else {
                        // Calculate sender target if sender stream present
                        if(stats.video && stats.video.senderTrack){
                        	if(_this.isLocalVideoMuted(_this.connection)){
                                _this.lastSenderUpdate.target = _this.videoMutedBandwidth;
                            }
                            else{
                                _this.calculateTargetBandwidth(stats.video.senderTrack, _this.lastSenderUpdate);
                            }
                        }
                        else if(stats.audio && stats.audio.sender){
                            _this.lastSenderUpdate.target = _this.audioOnlyBandwidth;
                        }

                        // Calculate receiver target if receiver stream present
                        if(stats.video && stats.video.receiverTrack){
                        	if(_this.isRemoteVideoMuted(_this.connection)){
                                _this.lastReceiverUpdate.target = _this.videoMutedBandwidth;    // In liveswitch, only tracks if remote video muted by you
                            }
                            else{
                                _this.calculateTargetBandwidth(stats.video.receiverTrack, _this.lastReceiverUpdate);
                            }
                        }
                        else if(stats.audio && stats.audio.receiver){
                            _this.lastReceiverUpdate.target = _this.audioOnlyBandwidth;
                        }

                        // Calculate connection quality
                        if(_this.connection instanceof fm.liveswitch.SfuUpstreamConnection){
                            //console.log(_this.userId, 'Target', _this.lastSenderUpdate.target);
                            connectionQuality = (_this.lastSenderUpdate.target) ? Math.ceil(100 * kilobitSentRate / _this.lastSenderUpdate.target) : 0;
                        }
                        else if(_this.connection instanceof fm.liveswitch.SfuDownstreamConnection){
                            //console.log(_this.userId, 'Target', _this.lastReceiverUpdate.target);
                            connectionQuality = (_this.lastReceiverUpdate.target) ? Math.ceil(100 * kilobitReceivedRate / _this.lastReceiverUpdate.target) : 0;
                        }
                        else {
                            const connectionQualitySender = (_this.lastSenderUpdate.target) ? Math.ceil(100 * kilobitSentRate / _this.lastSenderUpdate.target) : 0;
                            const connectionQualityReceiver = (_this.lastReceiverUpdate.target) ? Math.ceil(100 * kilobitReceivedRate / _this.lastReceiverUpdate.target) : 0;

                            if(!connectionQualityReceiver && connectionQualitySender){
                                connectionQuality = connectionQualitySender;
                            }
                            else if(!connectionQualitySender && connectionQualityReceiver){
                                connectionQuality = connectionQualityReceiver;
                            }
                            else{
                                connectionQuality = Math.min(connectionQualitySender, connectionQualityReceiver);
                            }
                        }

                        if(connectionQuality > 100){
                            connectionQuality = 100;
                        }
                    }
                }

                // Smoothing
                const timeNow = window.performance.now();

                if(_this.lastUpdateTime){
                    const maxChange = (timeNow - _this.lastUpdateTime) / 500;

                    if(connectionQuality > _this.lastConnectionQuality){
                        const increase = Math.min(connectionQuality - _this.lastConnectionQuality, maxChange);

                        _this.lastConnectionQuality = _this.lastConnectionQuality + increase;
                    }
                    else if(connectionQuality < _this.lastConnectionQuality){
                        const decrease = Math.min(_this.lastConnectionQuality - connectionQuality, maxChange);

                        _this.lastConnectionQuality = _this.lastConnectionQuality - decrease;
                    }
                }
                else{
                    _this.lastConnectionQuality = connectionQuality;
                }

                _this.lastUpdateTime = timeNow;

                const reducedStats = {
                    bitrate: {download: Math.ceil(kilobitReceivedRate), upload: Math.ceil(kilobitSentRate)},
                    connectionQuality: Math.round(_this.lastConnectionQuality),
                    frameRate: frameRate,
                    resolution: resolution,
                    packetLoss: {total: packetsLost, download: packetsLost, upload: 0}
                }

                userStats.stats = reducedStats;

                return userStats;
            })
            .fail(function(ex){
            	console.error('Stats error:', ex)
                //_this.webRTCHandler.onError(31, ex);
            })
        };

        this.lastSenderUpdate = {pixels: 0, increaseTime: 0, target: 0};
        this.lastReceiverUpdate = {pixels: 0, increaseTime: 0, target: 0};
        this.calculateTargetBandwidth = function(track, lastUpdate){
            let pixels = track.frameWidth * track.frameHeight;

            if(pixels > lastUpdate.pixels){
                lastUpdate.increaseTime = window.performance.now();
            }

            lastUpdate.pixels = pixels;

            const milliSecSincePixelIncrease = window.performance.now() - lastUpdate.increaseTime;
            if (milliSecSincePixelIncrease >= 3000){
                if (pixels <= 320 * 240) {
                    lastUpdate.target = 600;
                } else if (pixels <= 640 * 480) {
                    lastUpdate.target = 1700;
                } else if (pixels <= 960 * 540) {
                    lastUpdate.target = 2000;
                } else {
                    lastUpdate.target = 2000;
                }

                if(this.currentMaxBitrate > 0){
                    // Simulcast active
                    if(this.currentMaxBitrate === this.audioOnlyBandwidth && this.isLocalAudioMuted(this.connection)){
                        lastUpdate.target = Math.min(0.9 * lastUpdate.target, this.currentMaxBitrate - 30);
                    }
                    else{
                        lastUpdate.target = Math.min(0.9 * lastUpdate.target, this.currentMaxBitrate);
                    }
                }
            }

            return lastUpdate.target;
        };

		this.isLocalVideoMuted = function(connection){
			if(typeof connection.getLocalVideoMuted === 'function'){
				return connection.getLocalVideoMuted();
			}
			else{
				const videoStream = connection.getVideoStream();
				if(videoStream){
					return videoStream.getLocalTrack().getMedia().getVideoMuted()
				}
				else{
					return true;	// No video track would have similar bandwidth to muted video
				}
			}
		};

        this.isLocalAudioMuted = function(connection){
            if(typeof connection.getLocalAudioMuted === 'function'){
                return connection.getLocalAudioMuted();
            }
            else{
                const audioStream = connection.getAudioStream();
                if(audioStream){
                    return audioStream.getLocalTrack().getMedia().getAudioMuted()
                }
                else{
                    return true;	// No audio track would have similar bandwidth to muted audio
                }
            }
        };

		this.isRemoteVideoMuted = function(connection){
			return connection.getRemoteVideoMuted();
		}
    }

    getConnectionId(){
        return this.connection.getId();
    }

    start(){
        const _this = this;

        if(this.collector){
            this.stop();
        }

        this.previousStats = {
            audio: {sender: null, transport: null, receiver: null},
            video: {sender: null, transport: null, receiver: null}
        }

        this.timeConnected = window.performance.now();

        this.getConnectionStats()
        .then(function(userStats){
            _this.webRTCHandler.onStatsReceived(userStats)
        })

        this.collector = setInterval(() => {
            _this.getConnectionStats()
            .then(function(userStats){
                _this.webRTCHandler.onStatsReceived(userStats)
            });
        }, this.collectionInterval);
    }

    stop(){
        clearInterval(this.collector);
        this.collector = null;
    }

    simulcastChanged(numConnections){
        const videoStream = this.connection.getVideoStream();

        if(!videoStream){
            this.currentMaxBitrate = this.audioOnlyBandwidth;
            return;
        }

        let simulcastBitrate = 0;
        if(this.connection instanceof fm.liveswitch.SfuUpstreamConnection){
            // No connected peers means video not sent to server
            if(numConnections === 0){
                this.currentMaxBitrate = this.audioOnlyBandwidth;
                return;
            }

            const deactivatedByServer = videoStream._getInternal()._deactivatedByServer;
            const sendEncodings = videoStream._getInternal().getSendEncodings();

            for (let i = 0; i < sendEncodings.length; i++) {
                const sendEncoding = sendEncodings[i];

                if(i < deactivatedByServer.length){
                    const deactivated = deactivatedByServer[i];
                    if(!deactivated){
                        simulcastBitrate += parseInt(sendEncoding.getBitrate());
                    }
                }
            }

            //console.log('Upstream Simulcast Bitrate', simulcastBitrate);
        }
        else if(this.connection instanceof fm.liveswitch.SfuDownstreamConnection){
            if(videoStream && videoStream.getRemoteEncoding()){
                simulcastBitrate = videoStream.getRemoteEncoding().getBitrate();

                //console.log('Downstream Simulcast Bitrate', simulcastBitrate);
            }
        }

        if(simulcastBitrate > 0 && this.maxVideoBitrate > 0){
            this.currentMaxBitrate = Math.min(simulcastBitrate, this.maxVideoBitrate);
        }
        else if(simulcastBitrate == 0){
            this.currentMaxBitrate = this.maxVideoBitrate;
        }
        else if(this.maxVideoBitrate == 0){
            this.currentMaxBitrate = simulcastBitrate;
        }
    }
}